/* eslint-disable camelcase */
/* eslint-disable import/no-unresolved */
import React, { useCallback, useEffect } from 'react';

import { GroupChannelListItemBasicProps } from '@sendbird/uikit-react/types/modules/GroupChannelList/components/GroupChannelListItem/GroupChannelListItemView';
import { Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';

import {
  chatActiveTab,
  ClientChatTypes,
  getTypeOfUser,
  ServiceTypes,
  userIdSelector,
} from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import { extractNameFromChat } from '@pharmaplan/common/helpers/utils';

import useChatUserSeparation from '../../../../hooks/Chat/useChatUserSeparation';
import useChatSidebarUnread from '../../../../hooks/Chat/useChatSidebarUnread';
import useExistingMetadata from '../../../../hooks/Chat/useExistingMetadata';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import useChatStatus from '../../../../hooks/Chat/useChatStatus';
import useAdmin from '../../../../hooks/useAdmin';
import strings from '../../../../localization';
import ChatAvatar from '../ChatAvatar';

import styles from './styles';

const MessageTypes = {
  file: 'file',
};
export interface GroupChannelItemProps extends GroupChannelListItemBasicProps {}

const GroupChannelPreviewBase = (props: GroupChannelItemProps) => {
  const userId = useAppSelector(userIdSelector);
  const active = useAppSelector(chatActiveTab);
  const userType = useAppSelector(getTypeOfUser);

  const { handleUserType } = useChatSidebarUnread();
  const { isAdmin } = useAdmin();

  const { channel, isSelected } = props ?? {};
  const { style, label, isNotEngaged } = useChatStatus(channel);

  const isFullService = ServiceHandler.getService() === ServiceTypes.full;
  const showCount = isAdmin ? isNotEngaged : true;
  const isNotSupportOrUsers = active !== ClientChatTypes.support && active !== ClientChatTypes.users;

  const { lastMessage, name, unreadMessageCount, url, coverUrl } = channel ?? {};
  const { message, sender, messageType } = (lastMessage as any) ?? {};
  const { userId: senderId } = sender ?? {};
  const isMe = senderId === userId;

  const useExtractedName = isNotSupportOrUsers || isFullService;
  const extractedName = extractNameFromChat(name, userType);
  const { selectedSegment, userType: metadataUser } = useChatUserSeparation(url);
  const StatusModifier = useCallback(
    () =>
      (
        <Box sx={styles.statusContainer}>
          <img style={styles.avatar} src={coverUrl} alt={strings.banner} />
          <Tooltip title={label} disableHoverListener={!isNotEngaged}>
            <Box sx={[style, styles.dot]} />
          </Tooltip>
        </Box>
      ),
    [coverUrl, label, style, isNotEngaged],
  );

  useEffect(() => {
    if (isNotEngaged || !isAdmin) {
      handleUserType(url, metadataUser, unreadMessageCount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadataUser, unreadMessageCount]);

  useExistingMetadata(url);

  const showStatusModifier = isNotSupportOrUsers && isAdmin;
  const hideImage = isNotSupportOrUsers && !isAdmin;

  const visibleMessage = messageType === MessageTypes.file ? strings.image : message;

  return (
    <Tooltip title={label} disableHoverListener={isNotEngaged}>
      <Box
        sx={[
          styles.channelItemContainer,
          isSelected ? styles.selectedChannel : {},
          !selectedSegment && styles.hideUser,
        ]}
      >
        {showStatusModifier && <StatusModifier />}
        <Box sx={[styles.channelInfoContainer]}>
          {hideImage && <ChatAvatar url={url} />}
          <Box>
            <Typography sx={styles.channelTitle}>
              {useExtractedName ? extractedName : name}
            </Typography>
            <Typography sx={styles.lastMessage}>
              {isMe ? `${strings.you}: ` : ''}
              {visibleMessage || ''}
            </Typography>
          </Box>
        </Box>
        {showCount && !!unreadMessageCount && (
        <Box sx={[styles.count, styles.shakingCount]}>{unreadMessageCount}</Box>
        )}
      </Box>
    </Tooltip>
  );
};

export default GroupChannelPreviewBase;
